import React from 'react';
import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

/**
 * BaseCustomDropdownMenu Component
 * 
 * A reusable dropdown menu component based on Ant Design's Dropdown.
 * 
 * Props:
 * - items (array): An array of menu items to be displayed. Each item should have:
 *   - key (string): A unique identifier for the item.
 *   - label (ReactNode): The display label for the menu item.
 *   - icon (ReactNode, optional): An optional icon to be displayed alongside the label.
 *   - extra (string, optional): Additional text like keyboard shortcuts.
 *   - ...
 * - toggleElement (ReactNode): The element that toggles the dropdown when clicked.
 * - children (ReactNode): Alternative trigger element, such as a button.
 * - ...props: Additional props passed to the Dropdown component.
 *              See https://ant.design/components/dropdown
 */

export const BaseCustomDropdownMenu = ({
  items,
  toggleElement,
  children,
  onClick,
  ...props
}) => {
  return (
    <Dropdown menu={{ items, onClick }} {...props}>
      {children ?? (
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            {toggleElement ?? <span>Open Menu</span>}
            <DownOutlined />
          </Space>
        </a>
      )}
    </Dropdown>
  );
};
